<template>
  <div>
    <!-- 文件上传 -->
    <file-uploader
      v-if="editable || computedValue.length"
      :min="config.baseQuestionLimitMin || undefined"
      :max="config.baseQuestionLimitMax || undefined"
      ref="fileUploader"
      :tips="computedTips"
      :isShow="editable"
    />
    <!-- 文件展示 -->
    <div v-else>-</div>
  </div>
</template>

<script>
import { getCompMix } from "../../mixins/comp-mix";
import FileUploader from "@/components/file-uploader/index.vue";
export default {
  mixins: [getCompMix(true)],
  components: {
    FileUploader,
  },
  computed: {
    computedTips() {
      const tipsArr = ["文件格式支持.doc,.docx,.pdf,.xls,.xlsx，大小不超过10M"];
      if (this.config.baseQuestionLimitMin) {
        tipsArr.push(`至少上传${this.config.baseQuestionLimitMin}个文件`);
      }
      if (this.config.baseQuestionLimitMax) {
        tipsArr.push(`最多上传${this.config.baseQuestionLimitMax}个文件`);
      }
      return tipsArr;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化或回填数据
    init() {
      this.$refs.fileUploader &&
        this.$refs.fileUploader.initFileList(this.computedValue);
    },
    // 提供方法给外部，用于获取上传成功的照片地址
    getData() {
      const fileData = this.$refs.fileUploader.getData();
      console.log("fileData---", fileData);
      return fileData;
    },
  },
};
</script>

<style lang="scss" scoped></style>
